"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SET = 'SET';

var formReducer = function formReducer(state, action) {
  if (action.type === SET) {
    return _objectSpread({}, state, _defineProperty({}, action.field, action.payload));
  }

  return state;
};

var useForm = function useForm(_ref) {
  var _ref$initialValues = _ref.initialValues,
      initialValues = _ref$initialValues === void 0 ? {} : _ref$initialValues;

  var _useReducer = (0, _react.useReducer)(formReducer, Object.entries(initialValues).reduce(function (accu, i) {
    accu[i[0]] = i[1];
    return accu;
  }, {})),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      values = _useReducer2[0],
      dispatchValues = _useReducer2[1];

  var _useReducer3 = (0, _react.useReducer)(formReducer, Object.entries(initialValues).reduce(function (accu, i) {
    accu[i[0]] = null;
    return accu;
  }, {})),
      _useReducer4 = _slicedToArray(_useReducer3, 2),
      errors = _useReducer4[0],
      dispatchErrors = _useReducer4[1];

  var updateField = function updateField(name, value) {
    return dispatchValues({
      type: SET,
      field: name,
      payload: value
    });
  };

  var updateError = function updateError(name, value) {
    return dispatchErrors({
      type: SET,
      field: name,
      payload: value
    });
  };

  return {
    values: values,
    errors: errors,
    updateField: updateField,
    updateError: updateError
  };
};

var _default = useForm;
exports.default = _default;